module.exports = __webpack_public_path__ + "static/media/3.9642dc19.jpg";